var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLeftArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 16,
  viewBox: "0 0 17 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.3763 13.2071C10.9614 13.5976 10.2886 13.5976 9.8737 13.2071L5.09245 8.70711C4.67752 8.31658 4.67752 7.68342 5.09245 7.29289L9.8737 2.79289C10.2886 2.40237 10.9614 2.40237 11.3763 2.79289C11.7912 3.18342 11.7912 3.81658 11.3763 4.20711L7.34635 8L11.3763 11.7929C11.7912 12.1834 11.7912 12.8166 11.3763 13.2071Z",
  fill: "currentColor"
})));
export { SvgLeftArrow as ReactComponent };